import { useState } from "react";

const useMegaMenuMobileState = ( ) => {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [searchExpanded, setSearchExpanded] = useState(false);
 
  const [selectedMain, setSelectedMain] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);

  return { menuExpanded,
    searchExpanded,
    selectedMain,
    selectedSub,
    setMenuExpanded,
    setSearchExpanded,
    setSelectedMain,
    setSelectedSub,
  }
}

export default useMegaMenuMobileState;